import { useEffect, useState } from 'react';
import Accordion from '../components/Accordion/Accordion';
import { usePromptContext } from '../context/PromptContextType';
import DropDownComponent, {
  RangeSelector,
  SearchableDropDownComponent,
  ToolTipFunction
} from './inputField';
import { ReactComponent as I_icon } from '../assets/icon/i_icon.svg';
import { usePromptPlaygroundContext } from '../context/PromptPlayGroundContext';
import { useToast } from '../hooks/useToast';

export default function CreditBalanceBox() {
  const { showSuccess } = useToast();
  const {
    creditData,
    setSelectedApplication,
    selectedApplication,
    deduction,
    setDeduction,
    indexSelection,
    handleSetIndexData,
    resetIndexDetails,
    IndexOptions,
    setIndexOption
  } = usePromptContext();
  const {
    indexData = {
      data: [
        {
          vector_search_index_name: '',
          rag_app_id: '',
          ai_search_service_name: ''
        }
      ],
      modalData: { endpoints: [{ endpoint_name: '' }] }
    }
  } = usePromptPlaygroundContext();
  const { indexDetails, clearDeductionData } = usePromptPlaygroundContext();

  const {
    credit_remaining = 0,
    total_credit = 0,
    credit_id: CREDIT_ID = 0
  } = selectedApplication || {};

  const availableCredits = Number(Number(credit_remaining || 0));
  const TotalCredits = Number(Number(total_credit || 0));

  const [availableApplications, setAvailableApplications] =
    useState<{ title: string; id: string }[]>();

  useEffect(() => {
    if (creditData?.loading || creditData?.error) {
      return;
    }
    const temp_ = creditData?.data?.items || [];
    const temp = temp_?.map((item) => ({
      title: item?.application_name,
      id: item?.credit_id
    }));
    if (!!temp_?.length) {
      setSelectedApplication(temp_?.[0]);
      setAvailableApplications(temp);
    }
  }, [creditData]);

  useEffect(() => {
    resetIndexDetails();
  }, []);

  useEffect(() => {
    if (!!deduction) {
      showSuccess(
        `Credits Deducted: €${deduction} from Application ${selectedApplication?.application_name}`,
        {
          toastId: 'creditDeduction'
        }
      );

      setTimeout(() => {
        setDeduction(0);
        clearDeductionData();
      }, 10000);
    }
  }, [deduction]);
  // for rag Index Changes
  // populating index based on selected Application
  // const [IndexOptions, setIndexOption] = useState([{ title: '', id: '', serviceName: '' }]);
  useEffect(() => {
    const values_1 = indexData?.data;
    if (Array.isArray(values_1)) {
      const temp = values_1?.map((item) => {
        return {
          title: item?.vector_search_index_name,
          id: item?.rag_app_id,
          serviceName: item?.ai_search_service_name
        };
      });
      setIndexOption(temp || []);
    }
  }, [indexData]);

  useEffect(() => {
    // console.log(selectedApplication?.application_name, 'vvselectedApplication');
    indexDetails(selectedApplication?.application_name);
  }, [selectedApplication]);

  return (
    <div>
      {/* {!!deduction &&
        showSuccess(`Credits Deducted: €${deduction} &nbsp from Application fdsdsfdsf; `, {
          toastId: 'creditDeduction'
        })} */}
      <Accordion
        title={'Credit Balance'}
        isMandatory={false}
        rightButton={
          <div className="h6 w400  w-50 text-end m-0">
            <span className="un_standard_color w600">€{availableCredits?.toFixed(1)}</span>
            {/* <span className="w400" style={{ color: 'var(--description_grey)' }}>
              /{TotalCredits?.toFixed(1)}
            </span> */}
            <ToolTipFunction
              placement="bottom"
              toolTipText={
                <>
                  <span>Available Credits: {availableCredits}</span>
                  <br />
                  <span>Total Credits : {TotalCredits}</span>
                </>
              }>
              <I_icon />
            </ToolTipFunction>
          </div>
        }>
        <DropDownComponent
          fieldName="Billing Application"
          isMandatory={true}
          options={availableApplications}
          value={CREDIT_ID}
          handleSelection={(name, value) => {
            const temp = creditData?.data?.items?.filter((item) => item?.credit_id == value)?.[0];
            // indexDetails(temp?.application_name);
            setSelectedApplication(temp);
          }}></DropDownComponent>
      </Accordion>
      {/* {!!deduction && (
        <div
          className="p-2"
          style={{
            backgroundColor: 'rgba(255, 84, 79, 0.4)',
            height: '50px',
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            color: '#2b2b2b'
          }}>
          <span className="me-2">Credits Deducted: </span>
          <span className="fw-semibold"> €{deduction}</span> from
          <br />
          <span className="fw-semibold"> Credits Deducted:</span>
          <span className="fw-semibold"> Credits Deducted:</span>
          <span className="fw-semibold"> Credits Deducted:</span>
        </div>
      )} */}
      {/* {!!deduction && showSuccess(`Credits Deducted:€ ${deduction}`)} */}
      {CREDIT_ID ? (
        <Accordion title="Index" defaultOpen={false}>
          <SearchableDropDownComponent
            fieldName="Index"
            isMandatory={false}
            options={IndexOptions}
            paramName={'index'}
            value={indexSelection?.index}
            handleSelection={(a, b) => handleSetIndexData('index', b)}
          />

          {/* Search Top K , is only visibile when index is selected */}
          {!!indexSelection?.index && (
            <RangeSelector
              name={'Search Top K'}
              paramName={'search_top_k'}
              handleSelection={(a, b) => handleSetIndexData('topK', b)}
              min={0}
              max={10}
              steps={1}
              value={indexSelection?.topK}
            />
          )}
        </Accordion>
      ) : (
        <></>
      )}
    </div>
  );
}
